import React, { useMemo } from "react";
import { Button, Item, Message } from "semantic-ui-react";

import Modal from "../../../components/common/Modal";
import { Chip } from "../../../components/common/Chip";
import { SaleChild, Sale } from "../types";
import { formatDateTime } from "../../../helpers/dateAndTimeHelper";

import "./CheckInModal.css";

interface CheckInModalProps {
  open: boolean;
  sale: Sale;
  pendingCheckIns: { [key: string]: boolean };
  onClose: () => void;
  onCheckIn: (entry: any) => void;
  onCheckInAll: () => void;
}

const CheckInModal: React.FC<CheckInModalProps> = ({
  open,
  sale,
  pendingCheckIns,
  onClose,
  onCheckIn,
  onCheckInAll
}) => {
  // Get entries from the search result
  const entries = sale.details || [];
  const customer = sale.customer;

  // Check if all entries are already checked in
  const allCheckedIn = entries.every(entry => entry.checkedIn);

  const loading = useMemo(() => {
    return pendingCheckIns[sale.id.toString()];
  }, [sale, pendingCheckIns]);

  return (
    <Modal
      size="tiny"
      open={open}
      onClose={onClose}
      header={
        <>
          <h2>Sale ID: #{sale?.id}</h2>
          <span>{customer?.firstName} {customer?.lastName} • {customer?.email}</span>
          {allCheckedIn ? (
            <Message
              positive
              header="All attendees checked in"
              className="all-checked-in"
            />
          ) : (
            <Button
              fluid
              primary
              loading={loading}
              disabled={allCheckedIn || loading}
              onClick={onCheckInAll}
              style={{
                marginLeft: "0",
                marginTop: "1rem",
              }}
            >
              Check in all
            </Button>
          )}
        </>
      }
      actions={[
        <Button
          fluid
          onClick={onClose}
        >
          Done
        </Button>
      ]}
    >
      <Item.Group divided>
        {entries.map((entry: SaleChild) => {
          let checkInPending = false;

          const index = sale.details.findIndex((detail: any) => detail.id === entry.id);
          if (index !== -1) {
            checkInPending = pendingCheckIns[`${sale.id}-${index}`] || false;
          }

          return (
            <Item className="checkin-modal-entry" key={entry.id}>
              <div>
                <div>
                  <h3>
                    {entry.customer.firstName} {entry.customer.lastName}
                  </h3>
                  <span>{entry.ticketName}</span>
                </div>
                {entry.checkedIn && entry.checkedInAtLocal ? (
                  <Chip
                    positive
                    icon="check"
                  >
                    {formatDateTime(new Date(entry.checkedInAtLocal)).replaceAll(",", "").toUpperCase()}
                  </Chip>
                ) : (
                  <Button
                    loading={checkInPending}
                    disabled={entry.checkedIn || checkInPending || loading}
                    onClick={() => onCheckIn(entry)}
                  >
                    Check in
                  </Button>
                )}
              </div>
            </Item>
          );
        })}
      </Item.Group>
    </Modal>
  );
};

export default CheckInModal;
